export default "__VITE_ASSET__f9534617__"